export default function normalizePhone(value, maxLength = 18, lenient = true) {
    const len = (value && value.length) || 0;

    if (len === 0) return '';

    const phone = (lenient || value.indexOf('+') >= 0 ? '+' : '') + value.replace(/\D/g, '');

    return phone.slice(0, maxLength);
}
